import { LanguageInfo } from "../../common/StrongFB-interfaces";

export const EN_LANG_INFO: LanguageInfo = {
    latin: 'English',
    code: 'en',
    direction: 'ltr',
    native: 'English',
    defaultFontName: 'monospace',
    dateFormat: 'ddd D MMMM',
    calendar: 'gregorian',
};